export const catalogueSyncCopy = {
  en: {
    throughput: 'Recent throughput',
    recordsPerMinute: 'records/min',
    pagesPerMinute: 'pages/min',
    backlog: 'Unfinished source-date range',
    throughputNote:
      'Rates cover the last 15 minutes, including pauses. Backlog is measured from the last completed window to the one-hour safety cutoff; remaining record count and completion time are unknown.',

    minuteProgress: 'Progress · 1 minute',
    checkpointsIncluded: 'Checkpoints included',
    intervalIncrements: 'Interval increments',
    thisCheckpoint: 'This checkpoint',
    total: 'Total',
    totalsOnly: 'Totals',

    added: 'Added',
    updated: 'Updated',
    legacyChanged: 'Earlier added or updated',
    splitNote:
      'Added and updated are counted separately from deployment onward. Earlier combined changes cannot be split retroactively.',

    errors: {
      upstream_connect_timeout: 'Connection to NKP timed out before a response.',
      upstream_headers_timeout: 'NKP response headers timed out.',
      upstream_body_timeout: 'NKP response body stalled.',
      upstream_deadline_exceeded: 'The total NKP request deadline was exceeded.',

      upstream_timeout: 'The source request timed out. The last committed checkpoint is preserved.',
      upstream_dns_error: 'The source hostname could not be resolved. The checkpoint is preserved.',
      upstream_connection_error:
        'The connection to the source failed. The checkpoint is preserved.',
      upstream_tls_error:
        'The source TLS certificate could not be verified. The checkpoint is preserved.',

      record_normalization_failed:
        'A source record could not be normalized. The page was rolled back; inspect the record identifier below.',
      upstream_rate_limited:
        'The source rate-limited this request. The last committed checkpoint is preserved.',
      disk_reserve_low: 'The worker stopped to preserve the disk-space reserve.',
      sync_internal_error: 'An internal worker error stopped this run. Check the service journal.',
      upstream_transport_error:
        'The source request failed at the network layer. The checkpoint is preserved.',
    },
    eventsTitle: 'Event history',
    eventsNote:
      'Latest 30 progress checkpoints grouped by minute and run, plus 40 separate lifecycle/error events; retained for 30 days. Intervals sum available checkpoints only and may be partial. Older intervals show totals only.',
    allEvents: 'All events',
    problems: 'Problems only',
    noEvents: 'No matching events recorded.',
    window: 'Reporting period',
    events: {
      started: 'Started',
      progress: 'Checkpoint committed',
      running: 'Resumed',
      retry: 'Request retry',
      window_reduced: 'Window reduced',
      observed: 'State observed',
    },

    title: 'NKP catalogue updates',
    refresh: 'Refresh',
    loading: 'Loading update status…',
    unavailable: 'Update status could not be loaded.',
    baseline:
      'The original snapshot has not been fully reconciled. Successful incremental updates do not verify older missing changes or deletions.',
    completed: 'Changes processed through',
    lag: 'Update lag',
    none: 'No completed window',
    run: 'Run',
    state: 'Status',
    pages: 'Pages',
    records: 'Records checked',
    changed: 'Added or updated',
    retired: 'Retired',
    heartbeat: 'Last activity',
    error: 'Error',
    schedule: 'Nightly start: 03:45–03:50 Europe/Bratislava · multiple batches, up to 6 hours',
    statuses: {
      healthy: 'Up to date',
      behind: 'Catching up / behind',
      failed: 'Failed',
      not_configured: 'Not configured',
      disabled: 'Disabled',
      running: 'Running',
      paused: 'Paused',
      complete: 'Complete',
    },
  },
  sk: {
    throughput: 'Nedávna rýchlosť',
    recordsPerMinute: 'záznamov/min',
    pagesPerMinute: 'strán/min',
    backlog: 'Nedokončené obdobie zdroja',
    throughputNote:
      'Rýchlosť zahŕňa posledných 15 minút vrátane prestávok. Zostávajúce obdobie sa meria od posledného dokončeného okna po hodinový bezpečnostný odstup; počet zostávajúcich záznamov a čas dokončenia nie sú známe.',

    minuteProgress: 'Priebeh · 1 minúta',
    checkpointsIncluded: 'Zahrnuté kontrolné body',
    intervalIncrements: 'Prírastky za interval',
    thisCheckpoint: 'Tento kontrolný bod',
    total: 'Spolu',
    totalsOnly: 'Súhrnné počty',

    added: 'Pridané',
    updated: 'Aktualizované',
    legacyChanged: 'Skoršie pridané alebo aktualizované',
    splitNote:
      'Pridané a aktualizované záznamy sa počítajú samostatne od nasadenia. Skoršie súhrnné zmeny nemožno spätne rozdeliť.',

    errors: {
      upstream_connect_timeout: 'Pripojenie k NKP prekročilo časový limit pred odpoveďou.',
      upstream_headers_timeout: 'Hlavičky odpovede NKP prekročili časový limit.',
      upstream_body_timeout: 'Prenos tela odpovede NKP sa zastavil.',
      upstream_deadline_exceeded: 'Celkový časový limit požiadavky NKP bol prekročený.',

      upstream_timeout:
        'Požiadavka na zdroj prekročila časový limit. Uložený bod zostáva zachovaný.',
      upstream_dns_error: 'Názov zdroja sa nepodarilo preložiť. Uložený bod zostáva zachovaný.',
      upstream_connection_error: 'Spojenie so zdrojom zlyhalo. Uložený bod zostáva zachovaný.',
      upstream_tls_error: 'Certifikát zdroja sa nepodarilo overiť. Uložený bod zostáva zachovaný.',

      record_normalization_failed:
        'Zdrojový záznam sa nepodarilo normalizovať. Strana bola vrátená späť; skontrolujte identifikátor nižšie.',
      upstream_rate_limited:
        'Zdroj obmedzil počet požiadaviek. Posledný uložený bod zostáva zachovaný.',
      disk_reserve_low: 'Proces sa zastavil, aby zachoval rezervu miesta na disku.',
      sync_internal_error: 'Interná chyba zastavila beh. Skontrolujte denník služby.',
      upstream_transport_error: 'Sieťová požiadavka zlyhala. Uložený bod zostáva zachovaný.',
    },
    eventsTitle: 'História udalostí',
    eventsNote:
      'Posledných 30 bodov priebehu zoskupených podľa minúty a behu a 40 samostatných udalostí/chýb; uchované 30 dní. Intervaly sčítajú iba dostupné body a môžu byť neúplné. Staršie intervaly zobrazujú iba súhrnné počty.',
    allEvents: 'Všetky udalosti',
    problems: 'Iba problémy',
    noEvents: 'Žiadne zodpovedajúce udalosti.',
    window: 'Spracúvané obdobie',
    events: {
      started: 'Spustené',
      progress: 'Priebeh uložený',
      running: 'Obnovené',
      retry: 'Opakovanie požiadavky',
      window_reduced: 'Skrátené obdobie',
      observed: 'Pozorovaný stav',
    },

    title: 'Aktualizácie katalógu NKP',
    refresh: 'Obnoviť',
    loading: 'Načítava sa stav aktualizácií…',
    unavailable: 'Stav aktualizácií sa nepodarilo načítať.',
    baseline:
      'Pôvodný snímok ešte nebol úplne zosúladený. Úspešné prírastkové aktualizácie neoverujú staršie chýbajúce zmeny ani odstránené záznamy.',
    completed: 'Zmeny spracované do',
    lag: 'Oneskorenie aktualizácií',
    none: 'Žiadne dokončené obdobie',
    run: 'Beh',
    state: 'Stav',
    pages: 'Strany',
    records: 'Overené záznamy',
    changed: 'Pridané alebo aktualizované',
    retired: 'Vyradené',
    heartbeat: 'Posledná aktivita',
    error: 'Chyba',
    schedule: 'Nočný štart: 03:45–03:50 Europe/Bratislava · viac dávok, najviac 6 hodín',
    statuses: {
      healthy: 'Aktuálne',
      behind: 'Dobieha / oneskorené',
      failed: 'Zlyhalo',
      not_configured: 'Nenakonfigurované',
      disabled: 'Vypnuté',
      running: 'Prebieha',
      paused: 'Pozastavené',
      complete: 'Dokončené',
    },
  },
  cs: {
    throughput: 'Nedávná rychlost',
    recordsPerMinute: 'záznamů/min',
    pagesPerMinute: 'stran/min',
    backlog: 'Nedokončené období zdroje',
    throughputNote:
      'Rychlost zahrnuje posledních 15 minut včetně přestávek. Zbývající období se měří od posledního dokončeného okna po hodinový bezpečnostní odstup; počet zbývajících záznamů a čas dokončení nejsou známé.',

    minuteProgress: 'Průběh · 1 minuta',
    checkpointsIncluded: 'Zahrnuté kontrolní body',
    intervalIncrements: 'Přírůstky za interval',
    thisCheckpoint: 'Tento kontrolní bod',
    total: 'Celkem',
    totalsOnly: 'Souhrnné počty',

    added: 'Přidané',
    updated: 'Aktualizované',
    legacyChanged: 'Dřívější přidané nebo aktualizované',
    splitNote:
      'Přidané a aktualizované záznamy se počítají samostatně od nasazení. Dřívější souhrnné změny nelze zpětně rozdělit.',

    errors: {
      upstream_connect_timeout: 'Připojení k NKP překročilo časový limit před odpovědí.',
      upstream_headers_timeout: 'Hlavičky odpovědi NKP překročily časový limit.',
      upstream_body_timeout: 'Přenos těla odpovědi NKP se zastavil.',
      upstream_deadline_exceeded: 'Celkový časový limit požadavku NKP byl překročen.',

      upstream_timeout: 'Požadavek na zdroj překročil časový limit. Uložený bod zůstává zachován.',
      upstream_dns_error: 'Název zdroje se nepodařilo přeložit. Uložený bod zůstává zachován.',
      upstream_connection_error: 'Spojení se zdrojem selhalo. Uložený bod zůstává zachován.',
      upstream_tls_error: 'Certifikát zdroje se nepodařilo ověřit. Uložený bod zůstává zachován.',

      record_normalization_failed:
        'Zdrojový záznam se nepodařilo normalizovat. Strana byla vrácena zpět; zkontrolujte identifikátor níže.',
      upstream_rate_limited: 'Zdroj omezil počet požadavků. Poslední uložený bod zůstává zachován.',
      disk_reserve_low: 'Proces se zastavil, aby zachoval rezervu místa na disku.',
      sync_internal_error: 'Interní chyba zastavila běh. Zkontrolujte deník služby.',
      upstream_transport_error: 'Síťový požadavek selhal. Uložený bod zůstává zachován.',
    },
    eventsTitle: 'Historie událostí',
    eventsNote:
      'Posledních 30 bodů průběhu seskupených podle minuty a běhu a 40 samostatných událostí/chyb; uchované 30 dní. Intervaly sčítají pouze dostupné body a mohou být neúplné. Starší intervaly zobrazují pouze souhrnné počty.',
    allEvents: 'Všechny události',
    problems: 'Pouze problémy',
    noEvents: 'Žádné odpovídající události.',
    window: 'Zpracovávané období',
    events: {
      started: 'Spuštěno',
      progress: 'Průběh uložen',
      running: 'Obnoveno',
      retry: 'Opakování požadavku',
      window_reduced: 'Zkrácené období',
      observed: 'Pozorovaný stav',
    },

    title: 'Aktualizace katalogu NKP',
    refresh: 'Obnovit',
    loading: 'Načítá se stav aktualizací…',
    unavailable: 'Stav aktualizací se nepodařilo načíst.',
    baseline:
      'Původní snímek ještě nebyl plně sladěn. Úspěšné přírůstkové aktualizace neověřují starší chybějící změny ani odstraněné záznamy.',
    completed: 'Změny zpracované do',
    lag: 'Zpoždění aktualizací',
    none: 'Žádné dokončené období',
    run: 'Běh',
    state: 'Stav',
    pages: 'Strany',
    records: 'Ověřené záznamy',
    changed: 'Přidané nebo aktualizované',
    retired: 'Vyřazené',
    heartbeat: 'Poslední aktivita',
    error: 'Chyba',
    schedule: 'Noční start: 03:45–03:50 Europe/Bratislava · více dávek, nejvýše 6 hodin',
    statuses: {
      healthy: 'Aktuální',
      behind: 'Dohání / zpožděné',
      failed: 'Selhalo',
      not_configured: 'Nenakonfigurováno',
      disabled: 'Vypnuto',
      running: 'Probíhá',
      paused: 'Pozastaveno',
      complete: 'Dokončeno',
    },
  },
};
